import * as Sentry from '@sentry/node'
import { Utils } from '@microfrontends/react-components'

export type TAuthUser = {
    id: number
    resumeId: number
    userName: string
    userId: number
    firstName: string
    lastName: string
    profilePicture: string
    jobTitle: string
    accessToken: string
    refreshToken: string
    industryList: Array<any>
    jobLevelId: Array<any>
}

class UserService {
    private _user: Promise<TAuthUser | null>
    private _userResolver: ((value: PromiseLike<TAuthUser | null> | TAuthUser | null) => void) | null = null

    constructor() {
        this._user = new Promise<TAuthUser | null>((resolve) => {
            this._userResolver = resolve
        })
    }

    setUser(user: null | TAuthUser) {
        this._userResolver && this._userResolver(user)
    }

    /**
     * This will return a user promise, and will resolve to `TAuthUser` or `null` if user has not signed in
     */
    getUser(): Promise<TAuthUser | null> {
        return this._user
    }

    async getAccessToken(): Promise<string> {
        const user = await this.getUser()
        if (user === null) {
            return ''
        }
        return user?.accessToken || ''
    }

    /**
     * This method is called once in Master Layout when the component mounted
     */
    async authenticate(jsToken: string, wsToken: string): Promise<TAuthUser | null> {
        try {
            const response = await fetch(process.env.NEXT_PUBLIC_AUTH_API as string, {
                method: 'post',
                headers: {
                    'Content-Type': 'application/vnd.api+json',
                    Accept: 'application/vnd.api+json'
                },
                body: JSON.stringify({ jsToken, wsToken })
            })

            // If success
            if (response.status === 200) {
                const responseData = await response.json()

                const singleData = responseData.data[0]

                const user: TAuthUser = {
                    ...singleData.id,
                    ...singleData.attributes,
                    accessToken: Utils.encrypt(singleData.attributes.accessToken)
                }

                this.setUser(user)
                return user
            } else {
                // If fail
                this.setUser(null)
                return null
            }
        } catch (ex) {
            Sentry.captureException(ex)
            return null
        }
    }
}

export default new UserService()
